import React, { useMemo, useState } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { Intersection } from './queries/useGetAlreadyExistClaimsTeams.query';
import IntersectionNotification from './IntersectionNotification';
import { HeadersWrap, ShowAllWrap } from './MultipleServicesSelector.styles';

const HEADERS = ['Claims team', 'Organization', 'Services'];

const MIN_SHOWN_ITEMS = 5;

interface Props {
  amountOfAllServices?: number;
  intersections?: Intersection[];
}

const ClaimsTeamNotification: React.FC<Props> = ({ intersections, amountOfAllServices }) => {
  const [isAllShown, setIsAllShown] = useState(false);
  const more = useMemo(() => (intersections?.length || 0) - MIN_SHOWN_ITEMS, [intersections]);
  const hasShowAllButton = useMemo(
    () => !isAllShown && intersections?.length && intersections.length > MIN_SHOWN_ITEMS,
    [intersections, isAllShown]
  );

  if (!intersections?.length) return null;

  return (
    <Box margin={{ top: 'spacing24' }} data-testId="ClaimsTeamNotification">
      <Inscription color="danger" lineHeight="20px">
        Claims team(s) already exist for the combination of organizations and services selected:
      </Inscription>
      <HeadersWrap
        data-testId="intersections_legend"
        pad={{ horizontal: 'spacing12' }}
        background="legend"
        height="32px"
        round="container2Round"
        align="center"
        direction="row"
        margin={{ top: 'spacing12' }}
      >
        {HEADERS.map((header) => (
          <Inscription key={header} weight="bold" color="textBody" size="small" lineHeight="18px">
            {header}
          </Inscription>
        ))}
      </HeadersWrap>
      <Box
        margin={{ top: 'spacing8' }}
        border={{ size: 'small', color: 'border1' }}
        round={{
          size: '8px',
          ...(hasShowAllButton ? { corner: 'top' } : {}),
        }}
      >
        {intersections?.slice(0, isAllShown ? undefined : MIN_SHOWN_ITEMS)?.map((item) => (
          <IntersectionNotification
            key={item.teamId}
            intersection={item}
            amountOfAllServices={amountOfAllServices}
          />
        ))}
      </Box>
      {hasShowAllButton ? (
        <ShowAllWrap
          round={{ corner: 'bottom', size: '8px' }}
          pad="spacing12"
          align="center"
          justify="center"
        >
          <Inscription
            color="textAccent"
            lineHeight="20px"
            onClick={() => setIsAllShown(true)}
            data-testId={`shaw_all_${more}`}
            style={{ cursor: 'pointer' }}
          >
            Show More Claims Teams ({more})
          </Inscription>
        </ShowAllWrap>
      ) : null}
    </Box>
  );
};

export default ClaimsTeamNotification;
